import React from 'react';
import { Switch, Route } from 'react-router-dom';

import MapComponent from '../Map';
import DashboardComponent from '../DashBoard';
import NotFound from "./error404";
import Unauthorised from './error401';


export const Map = ({ match }) => (
    <Switch>
        <Route exact path={`${match.url}/time/:time`} component={MapComponent} />
        <Route exact path={`${match.url}`} component={MapComponent} />
        <Route path='*' component={NotFound} />
    </Switch>
);

export const Dashboard = (props) => {
    return(
        <Switch>
            <Route path={`${props.match.path}`} component={DashboardComponent} />
            <Route path='*' component={NotFound} />
        </Switch>
    );
};

export const Admin = ({ match }) => {
    return(
        <Switch>
            <Route exact path={`${match.url}/map`} component={MapComponent} />
            <Route path={`${match.url}`} component={DashboardComponent} />
            <Route path='*' component={NotFound} />
        </Switch>
    );
};

export const error404 = ({ match }) => (
    <Route path={`${match.url}`} component={NotFound} />
);

export const error401 = ({ match }) => (
    <Route path={`${match.url}`} component={Unauthorised} />
);

export const PropsRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (<Component {...props} {...rest}/>)}/>
);


// WEBPACK FOOTER //
// ./src/components/Route/index.js